import MightLikeFailure from "./MightLikeFailure";
import { DISAPPOINTED } from "../faceEmoji";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const MightLikeFailed = ({ additionalClasses }) => {
  const { getTranslation } = useRuntimeConstants();
  return (
    <MightLikeFailure
      titleTranslationKey="similar_items_fail_title"
      subTitleTranslationKey="similar_items_api_failure_subtitle"
      emojiType={DISAPPOINTED}
      ariaLabel={getTranslation("emoji_face_disappointed")}
      additionalClasses={additionalClasses}
    ></MightLikeFailure>
  );
};

export default MightLikeFailed;
